import axios from './api'

export const getSanferGlobal = () => {
  return axios.get('/site/content/global')
    .then(res => res.data.data)
}